'use strict';
import React, { Component, PropTypes } from 'react';
import Globalize from 'globalize';

var BfgLoanBox = require('./loanBox.js');
import { FormatMessage } from 'react-globalize';

class SectionLoans extends Component {

  constructor(props) {
    super(props);

    var imgPath;

    if (this.props.locale == 'es')
      imgPath = 'img/icons/bfgIconLoan.jpg';
    else
      imgPath = "img/icons/bfgIconLoan_en.png";

    this.state = {
      img: imgPath

    };

  }


  componentWillReceiveProps(nextProps) {

    if (!(this.props.locale == nextProps.locale)) {
      var imgPath;
      if (nextProps.locale == 'es')
        imgPath = 'img/icons/bfgIconLoan.jpg';
      else
        imgPath = "img/icons/bfgIconLoan_en.png";

      this.setState({
        img: imgPath
      });

    }
  }

  componentDidMount() {
    this.props.logPageView();
  }


  /**
   * @return {object}
   */
  render() {
    return (
      <div id="section9" className="content-section about-section sectionPage">
        <div className="row">
          <div className="col-lg-8 col-lg-offset-2 col-xs-10 col-xs-offset-1">
            <div className="row">
              <div className="col-xs-6 col-xs-offset-3 col-lg-4 col-lg-offset-4">
                <img className="img-responsive" src={this.state.img} />
              </div>
            </div>
            <br/>
          </div>
        </div>
        <div className='col-lg-8 col-lg-offset-2 col-xs-12 col-xs-offset-1'>
          <div className="row">
            <div className="col-md-6 col-xs-10">
              <div className="title-v1 service-block text-justify">
                <h3><FormatMessage locale={this.props.locale} path="loansPage/loanApplyQuestion" /></h3>
                <hr className="small" />
                <FormatMessage locale={this.props.locale} path="loansPage/loanOffer" />
                <br/><br/>
                <FormatMessage locale={this.props.locale} path="loansPage/loanNeeds" />
                <br/><br/>
               
                <br/><br/>
              </div>
            </div>
            <div className="col-md-6 col-xs-10">
              <div className="title-v1 service-block text-justify">
                <h3><FormatMessage locale={this.props.locale} path="loansPage/loanHadLoan" /></h3>
                <hr className="small" />
                <FormatMessage locale={this.props.locale} path="loansPage/loanClient" />
                <br/><br/>
                {
                  this.props.locale == 'es' ?
                  <div>
                    <a target="_blank" href="/locations">
                      <FormatMessage locale={this.props.locale} path="loansPage/loandHere" />
                    </a>&nbsp;<FormatMessage locale={this.props.locale} path="loansPage/loanFindStore" />
                  </div> 
                  : 
                  <div>
                    <FormatMessage locale={this.props.locale} path="loansPage/loanFindStore" />
                    <a target="_blank" href="/locations">
                      <FormatMessage locale={this.props.locale} path="loansPage/loandHere" />
                    </a>
                  </div>
                }
                <br/>
                <FormatMessage locale={this.props.locale} path="loansPage/loanComplaintN" />
                <br/><br/>
                <FormatMessage locale={this.props.locale} path="loansPage/loanRegulated" />
                <br/><br/><br/>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-lg-8 col-lg-offset-2 col-xs-12 col-xs-offset-1">
            <div className="col-md-6 col-xs-10">
              <p style={{textAlign:'center', fontSize:11}}><FormatMessage locale={this.props.locale} path="loansPage/loanDisclaimer" /><br /></p>
            </div>
          </div>
        </div>
        
      </div>
    );
  }

};

module.exports = (SectionLoans);



// WEBPACK FOOTER //
// ./js/sectionLoans.js